
<div class="c-dropdown" @click:outside="open = false" ref="dropdown">
  <button :disabled="disabled" type="button" @click.stop="toggleMenu()" class="c-dropdown-btn">
    <slot name="button"></slot>
  </button>
  <div :class="{ open: open, 'position-top': shouldOpenTop }" class="c-dropdown-content" :style="setStyle">
    <slot name="dropdown-item"></slot>
  </div>
</div>
